import React from "react";
import tw from "twin.macro";
import MapSection from "./MapSection";
import FacultyDawahSection from "./FacultyDawah";
import Faculty from "./Faculty";
// import MainFeature2 from "components/features/TwoColSingleFeatureWithStats.js";
// import MainFeature3 from "components/features/TwoColSingleFeatureWithStats2.js";
// import Features from "components/features/ThreeColWithSideImage.js";
import SingleCol from "components/faqs/SingleCol.js";
// adj
import Layout from "components/layouts/Layout";
// Page-level structural wrappers for consistent spacing & layout
const PageSection = tw.section`w-full py-1 lg:py-2`;
const SectionInner = tw.div`max-w-screen-xl mx-auto px-6 lg:px-8 bg-white`;
const SectionHeader = tw.div`mb-2 lg:mb-2`;
const SectionTitle = tw.h2`text-3xl lg:text-4xl font-bold text-gray-900`;

// export default () => {
//   return (
//     <>

//       <Layout>
//       <SingleCol/>

//               {/* <Features

//         subheading={<Subheading>Our Values</Subheading>}
//         heading="We follow these."
//         description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
//         cards={[
//           {
//             imageSrc: SupportIconImage,
//             title: "24/7 Support",
//             description: "Lorem ipsum donor amet siti ceali placeholder text alipiscing elit sed do eiusmod temport"
//           },
//           {
//             imageSrc: ShieldIconImage,
//             title: "Strong Teams",
//             description: "Lorem ipsum donor amet siti ceali placeholder text alipiscing elit sed do eiusmod temport"
//           },
//           {
//             imageSrc: CustomerLoveIconImage,
//             title: "Customer Satisfaction",
//             description: "Lorem ipsum donor amet siti ceali placeholder text alipiscing elit sed do eiusmod temport"
//           },
//         ]}
//         linkText=""
//       /> */}

//               <TeamCardGrid subheading={<Subheading>Our Team</Subheading>} />
//               <TwoColumnWithImage   />

//             <MapSection />

//       </Layout>

//     </>
//   );
// };

export default () => {
  return (
    <Layout>
      {/* Intro / Mission */}
      <PageSection>
        <SectionInner>
          <SectionHeader></SectionHeader>
          <SingleCol />
        </SectionInner>
      </PageSection>

      {/* Faculty */}
      <PageSection>
        <SectionInner>
          <SectionHeader></SectionHeader>
          <Faculty />
        </SectionInner>
      </PageSection>

      {/* Dawah & Outreach */}
      <PageSection>
        <SectionInner>
          <SectionHeader></SectionHeader>
          <FacultyDawahSection />
        </SectionInner>
      </PageSection>

      {/* Location */}
      <PageSection>
        <SectionInner>
          <SectionHeader>
            <SectionTitle>Our Location</SectionTitle>
          </SectionHeader>
          <MapSection />
        </SectionInner>
      </PageSection>
    </Layout>
  );
};
